import React, { useContext } from "react";
import { Toggle } from "material-ui";
import { BackgroundSyncUIContext } from "../hooks/useBackgroundSync";

const style = {
  padding: 12,
  fontSize: 16,
  paddingLeft: 16,
  boxSizing: "border-box"
};

const DebugSwitch = () => {
  const [visible, setVisible] = useContext(BackgroundSyncUIContext);
  return (
    <Toggle
      style={style}
      checked={visible}
      label={<div>Saving Status<br/>Toolbar</div>}
      onClick={() => setVisible(!visible)}
    />
  );
};

export default DebugSwitch;
